<template>
  <div class="house-list-container">
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" :inline="true" class="search-form">
        <el-form-item label="区域：">
          <el-select 
            v-model="queryParams.address" 
            placeholder="选择区域"
            clearable
            style="width: 120px;"
          >
            <el-option label="南区" value="南区"></el-option>
            <el-option label="北区" value="北区"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="楼栋号：">
          <el-input
            v-model="queryParams.building"
            placeholder="请输入楼栋号"
            clearable
            style="width: 180px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        
        <el-form-item label="房间号：">
          <el-input
            v-model="queryParams.roomNum"
            placeholder="请输入房间号"
            clearable
            style="width: 180px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        
        <!-- 新增三个表号搜索项 -->
        <el-form-item label="水表号：">
          <el-input
            v-model="queryParams.waterMeterNumber"
            placeholder="请输入水表号"
            clearable
            style="width: 180px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        
        <el-form-item label="电表号：">
          <el-input
            v-model="queryParams.meterNumber"
            placeholder="请输入电表号"
            clearable
            style="width: 180px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        
        <el-form-item label="燃气表号：">
          <el-input
            v-model="queryParams.gasMeterNumber"
            placeholder="请输入燃气表号"
            clearable
            style="width: 180px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        
        <el-form-item label="状态：">
          <el-select 
            v-model="queryParams.status" 
            placeholder="请选择状态"
            clearable
            style="width: 180px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option 
              v-for="(status, index) in statusList" 
              :key="index" 
              :label="status" 
              :value="status"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
          <el-button 
            type="success" 
            icon="el-icon-plus" 
            @click="handleAdd"
            class="btn-add"
          >
            添加房屋
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 统计卡片区域 - 只保留四个核心统计项 -->
    <div class="statistics-container">
      <el-row :gutter="16">
        <!-- 房屋总数 -->
        <el-col :xs="12" :sm="6" :md="6" :lg="6">
          <el-card class="stat-card stat-card-total" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon">
                <i class="el-icon-house"></i>
              </div>
              <div class="stat-info">
                <div class="stat-title">房屋总数</div>
                <div class="stat-value">{{ stats.totalCount || 0 }}</div>
                <div class="stat-unit">套</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <!-- 已出租 -->
        <el-col :xs="12" :sm="6" :md="6" :lg="6">
          <el-card class="stat-card stat-card-rented" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon">
                <i class="el-icon-success"></i>
              </div>
              <div class="stat-info">
                <div class="stat-title">已出租</div>
                <div class="stat-value">{{ stats.rentedCount || 0 }}</div>
                <div class="stat-percentage">{{ stats.rentedPercentage || 0 }}%</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <!-- 未出租 -->
        <el-col :xs="12" :sm="6" :md="6" :lg="6">
          <el-card class="stat-card stat-card-vacant" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon">
                <i class="el-icon-info"></i>
              </div>
              <div class="stat-info">
                <div class="stat-title">未出租</div>
                <div class="stat-value">{{ stats.vacantCount || 0 }}</div>
                <div class="stat-percentage">{{ stats.vacantPercentage || 0 }}%</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <!-- 总价值 -->
        <el-col :xs="12" :sm="6" :md="6" :lg="6">
          <el-card class="stat-card stat-card-value" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon">
                <i class="el-icon-data-analysis"></i>
              </div>
              <div class="stat-info">
                <div class="stat-title">总价值</div>
                <div class="stat-value">{{ formatCurrency(stats.totalValue) }}</div>
                <div class="stat-unit">元</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-title">
          <i class="el-icon-tickets"></i>
          房屋列表
        </div>
        <div class="table-actions">
          <el-input
            v-model="quickSearch"
            placeholder="快速搜索..."
            prefix-icon="el-icon-search"
            style="width: 200px; margin-right: 10px;"
            size="small"
            clearable
            @input="handleQuickSearch"
          />
          <el-button 
            icon="el-icon-refresh" 
            @click="refreshData"
            size="small"
            plain
          >
            刷新
          </el-button>
        </div>
      </div>
      
      <!-- 简化表格，移除复杂功能 -->
      <el-table
        ref="houseTable"
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
        @selection-change="handleSelectionChange"
        >
        <!-- 选择列 -->
        <el-table-column
          type="selection"
          width="55"
          align="center"
        />
        
        <!-- 序号列 -->
        <el-table-column 
          label="序号" 
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              {{ (pageIndex - 1) * pageSize + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>
        
        <!-- 区域 -->
        <el-table-column 
          prop="address" 
          label="区域" 
          width="150"
          show-overflow-tooltip
        />
        
        <!-- 楼栋号 -->
        <el-table-column 
          prop="building" 
          label="楼栋号" 
          width="120"
          align="center"
        />
        
        <!-- 房间号 -->
        <el-table-column 
          prop="roomNum" 
          label="房间号" 
          width="120"
          align="center"
        />
        
        <!-- 新增三个表号列 -->
        <el-table-column 
          prop="waterMeterNumber" 
          label="水表号" 
          width="150"
          align="center"
          show-overflow-tooltip
        />
        
        <el-table-column 
          prop="meterNumber" 
          label="电表号" 
          width="150"
          align="center"
          show-overflow-tooltip
        />
        
        <el-table-column 
          prop="gasMeterNumber" 
          label="燃气表号" 
          width="150"
          align="center"
          show-overflow-tooltip
        />
        
        <!-- 状态 -->
        <el-table-column 
          prop="status" 
          label="状态" 
          width="120"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag 
              :type="row.status === '已出租' ? 'success' : 'info'"
              size="small"
            >
              {{ row.status || '未出租' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <!-- 面积 -->
        <el-table-column 
          prop="roomSquare" 
          label="面积(㎡)" 
          width="120"
          align="right"
        >
          <template slot-scope="{ row }">
            <span>
              {{ formatNumber(row.roomSquare) }}
            </span>
          </template>
        </el-table-column>
        
        <!-- 价格 -->
        <el-table-column 
          prop="price" 
          label="价格(元)" 
          width="150"
          align="right"
        >
          <template slot-scope="{ row }">
            <span class="money-cell">
              {{ formatCurrency(row.price) }}
            </span>
          </template>
        </el-table-column>
        
        <!-- 详情 -->
        <el-table-column 
          prop="detail" 
          label="详情" 
          min-width="200"
          show-overflow-tooltip
        />
        
        <!-- 操作列 -->
        <el-table-column 
          label="操作" 
          width="350" 
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="action-buttons">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-view"
                @click="handleView(row)"
              >
                查看
              </el-button>
              
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(row)"
              >
                编辑
              </el-button>
              
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDelete(row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="footer-area">
        <el-pagination
          v-if="total > 0"
          class="pagination-container"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增/编辑房屋对话框 -->
    <HouseFormDialog
      :visible="formDialogVisible"
      :form-data="currentFormData"
      :is-edit="isEditMode"
      @close="handleFormDialogClose"
      @save="handleFormSave"
    />
    
    <!-- 房屋详情对话框 -->
    <HouseDetailDialog
      :visible="detailDialogVisible"
      :house-data="currentDetailData"
      @close="handleDetailDialogClose"
    />
  </div>
</template>

<script>
import houseApi from '../api/house.js'
import HouseFormDialog from '../components/HouseFormDialog'
import HouseDetailDialog from '../components/HouseDetailDialog'

export default {
  name: "HouseList",
  components: {
    HouseFormDialog,
    HouseDetailDialog
  },
  
  data() {
    return {
      // 加载状态
      loading: false,
      
      // 原始数据（保持不变）
      originalData: [],
      // 当前显示的数据
      tableData: [],
      // 筛选后的数据
      filteredData: [],
      total: 0,
      
      // 快速搜索
      quickSearch: '',
      
      // 分页参数
      pageIndex: 1,
      pageSize: 10,
      
      // 查询参数 - 新增三个表号字段
      queryParams: {
        address: '',
        building: '',
        roomNum: '',
        waterMeterNumber: '',  // 水表号
        meterNumber: '',       // 电表号
        gasMeterNumber: '',    // 燃气表号
        status: ''
      },
      
      // 状态列表
      statusList: ["未出租", "已出租"],
      
      // 对话框相关
      formDialogVisible: false,
      detailDialogVisible: false,
      isEditMode: false,
      currentFormData: {},
      currentDetailData: {},
      
      // 统计信息 - 只保留四个核心字段
      stats: {
        totalCount: 0,
        rentedCount: 0,
        vacantCount: 0,
        rentedPercentage: 0,
        vacantPercentage: 0,
        totalValue: 0
      },
      
      // 表格高度
      tableHeight: 500,
      
      // 搜索防抖
      searchTimer: null,
      
      // 防抖函数引用
      debouncedResize: null
    }
  },
  
  watch: {
    // 监听原始数据变化，更新统计信息
    originalData: {
      handler(newData) {
        this.updateStatistics(newData);
      },
      deep: true,
      immediate: true
    },
    
    // 监听筛选后的数据变化，更新统计信息
    filteredData: {
      handler(newData) {
        this.updateStatistics(newData);
      },
      deep: true
    }
  },
  
  created() {
    console.log('HouseList created');
    this.getProfile();
  },
  
  mounted() {
    console.log('HouseList mounted');
    this.initTableHeight();
    
    // 使用防抖的resize监听
    var self = this;
    this.debouncedResize = this.debounce(function() {
      self.initTableHeight();
    }, 150);
    
    window.addEventListener('resize', this.debouncedResize);
  },
  
  activated() {
    console.log('HouseList activated - 组件被激活');
    // 如果数据为空，重新加载
    if (this.originalData.length === 0) {
      this.getProfile();
    }
    
    // 重新计算表格高度
    this.$nextTick(function() {
      this.initTableHeight();
    });
  },
  
  beforeDestroy() {
    console.log('HouseList beforeDestroy');
    this.cleanup();
  },
  
  methods: {
    /**
     * 清理资源
     */
    cleanup() {
      console.log('清理资源');
      
      // 清除事件监听
      if (this.debouncedResize) {
        window.removeEventListener('resize', this.debouncedResize);
        this.debouncedResize = null;
      }
      
      // 清除定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      
      // 清空数据引用（避免内存泄漏）
      this.tableData = [];
      this.originalData = [];
      this.filteredData = [];
      this.total = 0;
      
      // 清空对话框数据
      this.currentFormData = null;
      this.currentDetailData = null;
      
      // 重置查询参数
      this.queryParams = {
        address: '',
        building: '',
        roomNum: '',
        waterMeterNumber: '',  // 重置水表号
        meterNumber: '',       // 重置电表号
        gasMeterNumber: '',    // 重置燃气表号
        status: ''
      };
      this.quickSearch = '';
      
      // 重置分页
      this.pageIndex = 1;
      this.pageSize = 10;
      
      // 重置统计信息
      this.stats = {
        totalCount: 0,
        rentedCount: 0,
        vacantCount: 0,
        rentedPercentage: 0,
        vacantPercentage: 0,
        totalValue: 0
      };
    },
    
    /**
     * 更新统计信息 - 简化为只计算四个核心统计项
     */
    updateStatistics(data) {
      if (!data || data.length === 0) {
        this.resetStatistics();
        return;
      }
      
      // 计算统计数据
      const totalCount = data.length;
      let rentedCount = 0;
      let vacantCount = 0;
      let totalPrice = 0;
      
      data.forEach(function(item) {
        // 统计状态
        if (item.status === '已出租') {
          rentedCount++;
        } else {
          vacantCount++;
        }
        
        // 计算总价值
        const price = Number(item.price) || 0;
        totalPrice += price;
      });
      
      // 计算百分比
      const rentedPercentage = totalCount > 0 ? ((rentedCount / totalCount) * 100).toFixed(1) : 0;
      const vacantPercentage = totalCount > 0 ? ((vacantCount / totalCount) * 100).toFixed(1) : 0;
      
      // 更新统计信息
      this.stats = {
        totalCount: totalCount,
        rentedCount: rentedCount,
        vacantCount: vacantCount,
        rentedPercentage: rentedPercentage,
        vacantPercentage: vacantPercentage,
        totalValue: totalPrice.toFixed(2)
      };
    },
    
    /**
     * 重置统计信息
     */
    resetStatistics() {
      this.stats = {
        totalCount: 0,
        rentedCount: 0,
        vacantCount: 0,
        rentedPercentage: 0,
        vacantPercentage: 0,
        totalValue: 0
      };
    },
    
    /**
     * 刷新数据
     */
    refreshData() {
      this.getProfile();
      this.$message.success('数据刷新成功');
    },
    
    /**
     * 防抖函数
     */
    debounce(func, wait) {
      var timeout;
      return function executedFunction() {
        var context = this;
        var args = arguments;
        var later = function() {
          clearTimeout(timeout);
          func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    
    /**
     * 初始化表格高度
     */
    initTableHeight() {
      // 使用固定高度或根据窗口计算
      var windowHeight = window.innerHeight;
      var containerTop = 300;
      
      // 安全地获取元素位置
      if (this.$el && this.$el.getBoundingClientRect) {
        var rect = this.$el.getBoundingClientRect();
        if (rect && rect.top) {
          containerTop = rect.top;
        }
      }
      
      // 调整高度，统计卡片区域已简化，减少高度占用
      this.tableHeight = Math.max(400, windowHeight - containerTop - 140);
    },
    
    /**
     * 获取房屋列表
     */
    getProfile() {
      if (this.loading) {
        console.log('已经在加载中，跳过重复请求');
        return;
      }
      
      var self = this;
      this.loading = true;
      console.log('开始加载房屋数据');
      
      // 设置超时保护
      var timeoutTimer = setTimeout(function() {
        if (self.loading) {
          console.warn('房屋数据加载超时，强制结束');
          self.loading = false;
          self.$message.error('数据加载超时，请刷新页面重试');
        }
      }, 10000); // 10秒超时
      
      houseApi.getAllHouseList().then(function(response) {
        clearTimeout(timeoutTimer);
        
        if (response && response.data && response.data.flag === true) {
          self.originalData = response.data.data || [];
          self.filteredData = response.data.data || [];
          self.total = self.originalData.length;
          
          // 应用当前筛选和分页
          self.applyFilter();
          
          console.log('已加载 ' + self.originalData.length + ' 条房屋数据');
          
          if (self.originalData.length === 0) {
            self.$message.info('暂无房屋数据');
          }
        } else {
          console.error('获取房屋信息列表失败:', response);
          self.$message.error('获取房屋信息列表失败');
          self.originalData = [];
          self.filteredData = [];
          self.total = 0;
          self.tableData = [];
          self.resetStatistics();
        }
      }).catch(function(error) {
        clearTimeout(timeoutTimer);
        
        console.error('获取房屋列表失败:', error);
        self.$message.error('加载失败，请检查网络连接');
        self.originalData = [];
        self.filteredData = [];
        self.total = 0;
        self.tableData = [];
        self.resetStatistics();
      }).finally(function() {
        self.loading = false;
      });
    },
    
    /**
     * 应用分页
     */
    applyPagination() {
      var start = (this.pageIndex - 1) * this.pageSize;
      var end = start + this.pageSize;
      this.tableData = this.filteredData.slice(start, end);
    },
    
    /**
     * 应用筛选（关键修复：基于原始数据筛选）
     */
    applyFilter() {
      var filtered = this.originalData.slice(); // 从原始数据开始筛选
      
      // 应用查询条件
      if (this.queryParams.address && this.queryParams.address.trim()) {
        var addressFilter = this.queryParams.address.trim();
        filtered = filtered.filter(function(item) {
          return item.address && item.address.includes(addressFilter);
        });
      }
      
      if (this.queryParams.building && this.queryParams.building.trim()) {
        var buildingFilter = this.queryParams.building.trim();
        filtered = filtered.filter(function(item) {
          return item.building && item.building.includes(buildingFilter);
        });
      }
      
      if (this.queryParams.roomNum && this.queryParams.roomNum.trim()) {
        var roomNumFilter = this.queryParams.roomNum.trim();
        filtered = filtered.filter(function(item) {
          return item.roomNum && item.roomNum.includes(roomNumFilter);
        });
      }
      
      // 新增三个表号筛选条件
      if (this.queryParams.waterMeterNumber && this.queryParams.waterMeterNumber.trim()) {
        var waterMeterFilter = this.queryParams.waterMeterNumber.trim();
        filtered = filtered.filter(function(item) {
          return item.waterMeterNumber && item.waterMeterNumber.includes(waterMeterFilter);
        });
      }
      
      if (this.queryParams.meterNumber && this.queryParams.meterNumber.trim()) {
        var meterFilter = this.queryParams.meterNumber.trim();
        filtered = filtered.filter(function(item) {
          return item.meterNumber && item.meterNumber.includes(meterFilter);
        });
      }
      
      if (this.queryParams.gasMeterNumber && this.queryParams.gasMeterNumber.trim()) {
        var gasMeterFilter = this.queryParams.gasMeterNumber.trim();
        filtered = filtered.filter(function(item) {
          return item.gasMeterNumber && item.gasMeterNumber.includes(gasMeterFilter);
        });
      }
      
      if (this.queryParams.status) {
        var statusFilter = this.queryParams.status;
        filtered = filtered.filter(function(item) {
          return item.status === statusFilter;
        });
      }
      
      // 快速搜索 - 增加三个表号的快速搜索
      if (this.quickSearch && this.quickSearch.trim()) {
        var search = this.quickSearch.trim().toLowerCase();
        filtered = filtered.filter(function(item) {
          return (
            (item.address && item.address.toLowerCase().includes(search)) ||
            (item.building && item.building.toLowerCase().includes(search)) ||
            (item.roomNum && item.roomNum.toLowerCase().includes(search)) ||
            (item.waterMeterNumber && item.waterMeterNumber.toLowerCase().includes(search)) || // 水表号
            (item.meterNumber && item.meterNumber.toLowerCase().includes(search)) ||            // 电表号
            (item.gasMeterNumber && item.gasMeterNumber.toLowerCase().includes(search)) ||     // 燃气表号
            (item.detail && item.detail.toLowerCase().includes(search))
          );
        });
      }
      
      // 更新筛选后的数据和总数
      this.filteredData = filtered;
      this.total = filtered.length;
      this.pageIndex = 1; // 重置到第一页
      this.applyPagination();
    },
    
    /**
     * 处理搜索
     */
    handleSearch() {
      this.applyFilter();
      if (this.filteredData.length === 0) {
        this.$message.info('未找到符合条件的房屋');
      } else {
        this.$message.success('找到 ' + this.filteredData.length + ' 条符合条件的房屋');
      }
    },
    
    /**
     * 处理快速搜索（防抖）
     */
    handleQuickSearch() {
      var self = this;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(function() {
        self.applyFilter();
      }, 300);
    },
    
    /**
     * 处理重置
     */
    handleReset() {
      this.queryParams = {
        address: '',
        building: '',
        roomNum: '',
        waterMeterNumber: '',  // 重置水表号
        meterNumber: '',       // 重置电表号
        gasMeterNumber: '',    // 重置燃气表号
        status: ''
      };
      this.quickSearch = '';
      this.pageIndex = 1;
      this.applyFilter(); // 直接应用筛选，而不是重新加载
    },
    
    /**
     * 处理选择变化
     */
    handleSelectionChange(selection) {
      // 如果不需要多选功能，可以移除这个处理
      console.log('选择了', selection.length, '行');
    },
    
    /**
     * 处理添加
     */
    handleAdd() {
      this.currentFormData = {};
      this.isEditMode = false;
      this.formDialogVisible = true;
    },
    
    /**
     * 处理编辑
     */
    handleEdit(row) {
      this.currentFormData = {
        houseid: row.houseid,
        address: row.address,
        building: row.building,
        price: row.price,
        roomNum: row.roomNum,
        status: row.status,
        detail: row.detail,
        roomSquare: row.roomSquare,
        // 新增三个表号字段
        waterMeterNumber: row.waterMeterNumber,
        meterNumber: row.meterNumber,
        gasMeterNumber: row.gasMeterNumber
      };
      
      this.isEditMode = true;
      this.formDialogVisible = true;
    },
    
    /**
     * 处理查看详情
     */
    handleView(row) {
      this.currentDetailData = Object.assign({}, row);
      this.detailDialogVisible = true;
    },
    
    /**
     * 处理删除
     */
    handleDelete(row) {
      var houseName = (row.address || '') + ' ' + (row.building || '') + '栋 ' + (row.roomNum || '') + '室';
      houseName = houseName.trim();
      
      var self = this;
      this.$confirm('确定要删除房屋 "' + houseName + '" 吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function() {
        return houseApi.deleteHouse(row.houseid);
      }).then(function(response) {
        if (response.data && response.data.flag === true) {
          self.$message.success('房屋 "' + houseName + '" 删除成功');
          // 重新加载数据
          self.getProfile();
        } else {
          self.$message.error('删除失败');
        }
      }).catch(function(error) {
        if (error && error !== 'cancel') {
          console.error('删除失败:', error);
          self.$message.error('删除失败，请重试');
        }
      });
    },
    
    /**
     * 处理分页大小变化
     */
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.applyPagination();
    },
    
    /**
     * 处理页码变化
     */
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.applyPagination();
    },
    
    /**
     * 处理表单对话框关闭
     */
    handleFormDialogClose() {
      this.formDialogVisible = false;
      this.currentFormData = {};
    },
    
    /**
     * 处理详情对话框关闭
     */
    handleDetailDialogClose() {
      this.detailDialogVisible = false;
      this.currentDetailData = {};
    },
    
    /**
     * 处理表单保存
     */
    handleFormSave(formData) {
      var self = this;
      var promise;
      
      if (this.isEditMode) {
        // 编辑模式
        promise = houseApi.updateHouse(formData);
      } else {
        // 新增模式
        promise = houseApi.addHouse(formData);
      }
      
      promise.then(function(response) {
        if (response && response.data && response.data.flag === true) {
          self.$message.success(self.isEditMode ? '更新成功' : '新增成功');
          self.formDialogVisible = false;
          self.currentFormData = {};
          // 重新加载数据
          self.getProfile();
        } else {
          var message = (response && response.data && response.data.message) || '保存失败';
          self.$message.error(message);
        }
      }).catch(function(error) {
        console.error('保存失败:', error);
        self.$message.error('保存失败，请重试');
      });
    },
    
    /**
     * 格式化数字
     */
    formatNumber(value) {
      if (value == null || value === '' || value === 0) return '0';
      var num = Number(value);
      if (isNaN(num)) return '0';
      return num.toFixed(2);
    },
    
    /**
     * 格式化货币
     */
    formatCurrency(value) {
      if (value == null || value === '' || value === 0) return '0';
      var num = Number(value);
      if (isNaN(num)) return '0';
      return num.toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }
  }
}
</script>

<style scoped>
:deep(.menu_page) {
  position: fixed !important;
  top: 71px !important;
  left: 0 !important;
  height: calc(100vh - 71px) !important;
  overflow: hidden !important;
}
.house-list-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(90vh - 84px);
}

.search-card {
  margin-bottom: 20px;
  border-radius: 8px;
  border: none;
}

.search-form {
  margin-bottom: -10px;
}

.btn-add {
  background-color: #67c23a;
  border-color: #67c23a;
  color: white;
}

.btn-add:hover {
  background-color: #5daf34;
  border-color: #5daf34;
  color: white;
}

/* 统计卡片区域 */
.statistics-container {
  margin-bottom: 20px;
}

.stat-card {
  border-radius: 8px;
  border: none;
  margin-bottom: 16px;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}

.stat-content {
  display: flex;
  align-items: center;
  padding: 16px;
}

.stat-icon {
  font-size: 36px;
  margin-right: 16px;
  width: 50px;
  text-align: center;
}

.stat-info {
  flex: 1;
}

.stat-title {
  font-size: 14px;
  color: #909399;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 2px;
  line-height: 1;
}

.stat-unit {
  font-size: 12px;
  color: #409EFF;
  font-weight: 500;
}

.stat-percentage {
  font-size: 12px;
  color: #67c23a;
  font-weight: 500;
}

/* 卡片颜色主题 */
.stat-card-total .stat-icon {
  color: #409EFF;
}

.stat-card-total {
  border-left: 4px solid #409EFF;
}

.stat-card-rented .stat-icon {
  color: #67c23a;
}

.stat-card-rented {
  border-left: 4px solid #67c23a;
}

.stat-card-vacant .stat-icon {
  color: #909399;
}

.stat-card-vacant {
  border-left: 4px solid #909399;
}

.stat-card-value .stat-icon {
  color: #b37feb;
}

.stat-card-value {
  border-left: 4px solid #b37feb;
}

.table-card {
  border-radius: 8px;
  overflow: hidden;
  border: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
}

.table-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.table-title i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 20px;
}

.table-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-area {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.pagination-container {
  text-align: right;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.money-cell {
  font-family: 'Arial', sans-serif;
  font-weight: 600;
  color: #f56c6c;
}

/* 简化样式，移除不必要的复杂样式 */
.el-table {
  font-size: 14px;
}

.el-table th {
  background-color: #f5f7fa !important;
  font-weight: 600;
}

.el-table td {
  padding: 12px 0;
}

.el-tag {
  min-width: 70px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .stat-icon {
    font-size: 32px;
    margin-right: 12px;
    width: 40px;
  }
  
  .stat-value {
    font-size: 20px;
  }
}

@media (max-width: 992px) {
  .statistics-container .el-col {
    margin-bottom: 12px;
  }
  
  .stat-content {
    padding: 12px;
  }
  
  .stat-icon {
    font-size: 28px;
    margin-right: 10px;
    width: 36px;
  }
  
  .stat-value {
    font-size: 18px;
  }
  
  .stat-title {
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .table-actions {
    width: 100%;
    justify-content: flex-start;
  }
  
  .house-list-container {
    padding: 12px;
  }
}
</style>

<style>
/* 移除全局复杂样式，使用默认样式 */
.house-list-container .el-table--border {
  border: 1px solid #ebeef5;
}

.house-list-container .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f5f7fa;
}

.house-list-container .el-table__header th {
  background-color: #f5f7fa !important;
}

/* 移除响应式样式，使用默认响应式 */
/* 对话框样式简化 */
.house-list-container .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
}

/* 分页器样式简化 */
.house-list-container .el-pagination {
  padding: 10px 0;
}

/* 优化表格性能 */
.house-list-container .el-table__body-wrapper {
  overflow-x: hidden !important;
}
</style>